<template>    
    <div class="mapCopyright text-right">{{basemapCopyright}}</div>   
</template>

<script>
export default {  
    props: {
        basemapCopyright : "",
        basemaps : null
    },
    data() {
        return {          
        }
    },    
}
</script>